import { useCallback } from 'react';
import { Lead, Contact, Page } from '../../../types';
import { createModuleLogger } from '../../../utils/logger';
import { contactPhoneKey } from '../../../utils/phoneUtils';
import { notify } from '../../../utils/toast';

const log = createModuleLogger('[KanbanChat]');


/**
 * Hook responsável pela integração do Kanban com o Chat.
 * Segue SRP isolando a lógica de navegação e validação de contato para chat.
 */
export const useKanbanChat = (
    contacts: Contact[],
    setCurrentPage: (page: Page) => void
) => {
    const handleChatClick = useCallback((lead: Lead) => {
        // Tenta encontrar o contato associado ao lead
        const contact = contacts.find(c => c.id === lead.contactId);

        // Fallback: Usa dados do contato OU do lead se contato não for encontrado
        // Resolve intermitência caso contatos não estejam carregados na memória
        const phoneNumber = contactPhoneKey(
            contact?.whatsapp || contact?.phone || lead.whatsApp || ''
        );
        const name = contact?.name || lead.name;

        if (!phoneNumber) {
            notify.warning(
                `Não foi possível abrir o chat para "${name}". Nenhum número de telefone encontrado.`
            );
            log.warn('Sem telefone para lead ID:', lead.id);
            return;
        }

        try {
            localStorage.setItem('chat_auto_start', JSON.stringify({
                number: phoneNumber,
                name: contact?.name || lead.name,
                timestamp: Date.now()
            }));

            // Navega para a página de chat
            setCurrentPage('chat');
        } catch (error) {
            log.error('Erro ao salvar dados do chat:', error);
            notify.error('Não foi possível abrir o chat. Tente novamente.');
        }
    }, [contacts, setCurrentPage]);

    return {
        handleChatClick
    };
};
